import { render } from "./CallsStats.vue?vue&type=template&id=0adc946e&scoped=true"
import script from "./CallsStats.vue?vue&type=script&lang=js"
export * from "./CallsStats.vue?vue&type=script&lang=js"

import "./CallsStats.vue?vue&type=style&index=0&id=0adc946e&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adc946e"]])

export default __exports__